<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <td style="width: 30px;">{{ index + 1 }}</td>
    <td
      style="width: 320px;"
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_PRODUCT_ID')
      }"
    >
      <input type="hidden" v-model="item.ID" />

      <Multiselect
        label="NAME"
        class="multiselect-multiline--max-content form-control i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register multiselect-multiline multiselect-mh-220"
        :limit="1"
        :limitText="filterItemText"
        track-by="ID"
        v-model="item.UF_PRODUCT_ID"
        :options="filterProducts()"
        :multiple="false"
        @input="changeTypeProject"
        placeholder="Продукт"
      >
        <span slot="noOptions">Продукт не найден</span>
        <span slot="noResult">Продукт не найден</span>
      </Multiselect>
      <div class="error-text"></div>
    </td>
    <td
      style="width: 380px;"
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_PRODUCT_TEXT')
      }"
    >
      <textarea
        class="i-main-style t-co-executor-style t-dop-style"
        v-model="item.UF_PRODUCT_TEXT"
        maxlength="200"
        style="width: 96%"
        @keyup="$parent.removeError(index, 'UF_PRODUCT_TEXT')"
      />
      <div class="error-text"></div>
    </td>
    <td
      style="width: 305px;"
      class="td--multiselect-mx-280"
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_OKPD2')
      }"
    >
      <Multiselect
        label="CODE"
        class="form-control i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register multiselect-multiline multiselect-mh-220 multiselect-mw-300"
        :limit="10"
        :limitText="filterItemText"
        track-by="CODE"
        v-model="item.UF_OKPD2"
        :options="cCode"
        :multiple="true"
        placeholder="ОКПД2"
      >
        <span slot="noOptions">Код не найден</span>
        <span slot="noResult">Код не найден</span>
      </Multiselect>
      <div class="error-text"></div>
    </td>

    <td
      style="width: 305px;"
      class="td--multiselect-mx-280"
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_TN_VED')
      }"
    >
      <Multiselect
        label="CODE"
        class="form-control i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register multiselect-multiline multiselect-mh-220 multiselect-mw-300"
        :limit="10"
        :limitText="filterItemText"
        track-by="CODE"
        v-model="item.UF_TN_VED"
        :options="cTnVed"
        :multiple="true"
        placeholder="ТН ВЭД"
      >
        <span slot="noOptions">Код не найден</span>
        <span slot="noResult">Код не найден</span>
      </Multiselect>

      <div class="error-text"></div>
    </td>

    <td class="cnt" v-if="currentUser.TYPE_USER !== 'declarer'">
      <label class="switch">
        <input
          type="checkbox"
          v-model="item.UF_IS_DOUBLE"
        />
        <span class="slider round"></span>
      </label>
    </td>
    <td v-if="currentUser.TYPE_USER !== 'declarer'"
        style="padding-left: 14px;">
                <textarea
                  v-if="item.UF_IS_DOUBLE"
                  class="i-main-style t-co-executor-style t-dop-style"
                  v-model="item.UF_DOUBLE_TEXT"
                  style="width: 96%"
                />
    </td>

    <td style="width: 30px;">
      <a
        v-show="!$parent.$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteItem(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["item", "index"],
  name: "ProjectProductsV3List",
  methods: {
    filterProducts() {
      let version = 3;
      if (
        this.project.UF_SETTING &&
        parseInt(this.project.UF_SETTING.VERSION_PRODUCT_LIST) > 0
      ) {
        version = parseInt(this.project.UF_SETTING.VERSION_PRODUCT_LIST);
      }

      let t = this.directory.sp_project_products_list.filter(
        el => el.VERSION === version
      );
      return t;
    },
    changeTypeProject() {
      if (Object.prototype.toString.call(this.item.UF_PRODUCT_ID) === "[object Object]") {
        this.item.UF_OKPD2 = "";
        this.item.UF_TN_VED = "";
        this.$parent.removeError(this.index, "UF_PRODUCT_ID");
        this.$parent.removeError(this.index, "UF_OKPD2");
        this.$parent.removeError(this.index, "UF_TN_VED");
      } else {
        this.item.UF_PRODUCT_ID = 0;
        this.item.UF_OKPD2 = "";
        this.item.UF_PRODUCT_TEXT = "";
        this.item.UF_TN_VED = "";
      }
    },
    filterItemText(count) {
      console.log(count);
      return ``;
    }
  },
  computed: {
    ...mapGetters(["project", "directory", "currentUser"]),
    cCode() {
      if (this.item.UF_PRODUCT_ID.ID < 1) {
        return [];
      }
      let t = null;
      t = this.directory.sp_project_products_list.filter(
        c => c.ID === this.item.UF_PRODUCT_ID.ID
      );

      if (t.length > 0) {
        return t[0].OKPD2;
      }

      return [];
    },
    cTnVed() {
      if (this.item.UF_PRODUCT_ID.ID < 1) {
        return [];
      }
      let t = null;
      t = this.directory.sp_project_products_list.filter(
        c => c.ID === this.item.UF_PRODUCT_ID.ID
      );

      if (t.length > 0) {
        return t[0].TN_VED;
      }

      return [];
    }
  }
};
</script>

<style scoped></style>
